function buildQuery(params = {}) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null && value !== "") search.set(key, String(value));
  }
  const q = search.toString();
  return q ? `?${q}` : "";
}

async function requestJson(path, options = {}) {
  const res = await fetch(path, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
}

export async function fetchAdminPredictivePricing(params = {}) {
  return requestJson(`/api/admin/mobility/predictive-pricing${buildQuery(params)}`);
}

export async function recalculateListingPredictivePrice(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/recalculate-predictive-price`,
    { method: "POST" }
  );
}

export async function recalculateAllPredictivePrices(params = {}) {
  return requestJson(
    `/api/admin/mobility/predictive-pricing/recalculate${buildQuery(params)}`,
    { method: "POST" }
  );
}

export async function fetchAdminPricingModels() {
  return requestJson("/api/admin/mobility/pricing-models");
}

export async function trainPricingModel(body = {}) {
  return requestJson("/api/admin/mobility/pricing-models/train", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function activatePricingModel(modelId) {
  return requestJson(
    `/api/admin/mobility/pricing-models/${encodeURIComponent(modelId)}/activate`,
    { method: "POST" }
  );
}

export async function deactivatePricingModel(modelId) {
  return requestJson(
    `/api/admin/mobility/pricing-models/${encodeURIComponent(modelId)}/deactivate`,
    { method: "POST" }
  );
}
